import Aura from '@primeuix/themes/aura';

const Orange = {
  ...Aura,
  semantic: {
    ...Aura.semantic,
    primary: {
      50: '#fef7ee',
      100: '#fdedd7',
      200: '#fad7ae',
      300: '#f6ba7b',
      400: '#f29345',
      500: '#ee7623',
      600: '#df5b17',
      700: '#b94515',
      800: '#933719',
      900: '#773017'
    }
  }
} as any;

export default Orange;
